module.exports = __webpack_public_path__ + "static/media/pg16.15754ac1.jpg";